<template>
  <router-view />
</template>
<script>
  export default {
    name: 'RegionalModule',
  }
</script>
